/* eslint-disable react-refresh/only-export-components */
import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        success:
          "border-transparent bg-success/15 text-success hover:bg-success/20",
        info: "border-transparent bg-info text-info-foreground hover:bg-info/80",
        warning:
          "border-transparent bg-warning text-warning-foreground hover:bg-warning/80",
        outline: "text-foreground",
        // NOTE: NSAI-6259 — the accent badge used to put brand ink on a brand
        // fill. Stacked (the model info card shows six of them at once) that
        // is a block of purple reading as a block of purple; the fill already
        // marks the badge, so the label takes the surface's own ink.
        accent: "bg-accent text-accent-foreground border-accent",
        muted:
          "gap-1 pr-1 cursor-pointer select-none border-border/50 bg-muted text-foreground hover:bg-accent focus:ring-0 focus:ring-offset-0",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface IBadgeProps
  extends
    React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: IBadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
